import React from 'react';
import { Check, X } from 'lucide-react';

interface FeatureRow {
  feature: string;
  free: boolean;
  starter: boolean;
  reader: boolean;
  ultra: boolean;
}

const features: FeatureRow[] = [
  // Starter features (available in Starter and above)
  { feature: 'Stories included', free: false, starter: true, reader: true, ultra: true },
  { feature: 'Upload your own texts', free: false, starter: true, reader: true, ultra: true },
  { feature: 'Progress saving', free: false, starter: true, reader: true, ultra: true },
  { feature: 'Session history', free: false, starter: true, reader: true, ultra: true },
  { feature: 'Basic analytics', free: false, starter: true, reader: true, ultra: true },
  // Reader features (available in Reader and above)
  { feature: 'Upload epub files', free: false, starter: false, reader: true, ultra: true },
  { feature: 'Achievements', free: false, starter: false, reader: true, ultra: true },
  { feature: 'XP & levels', free: false, starter: false, reader: true, ultra: true },
  { feature: 'Streak tracking', free: false, starter: false, reader: true, ultra: true },
  { feature: 'Streak multipliers', free: false, starter: false, reader: true, ultra: true },
  { feature: 'Full analytics', free: false, starter: false, reader: true, ultra: true },
  { feature: 'Priority support', free: false, starter: false, reader: true, ultra: true },
  // Ultra features (available in Ultra only)
  { feature: 'Cloud sync', free: false, starter: false, reader: false, ultra: true },
  { feature: 'History export', free: false, starter: false, reader: false, ultra: true },
  { feature: 'Streak freezes', free: false, starter: false, reader: false, ultra: true },
  { feature: 'Early access', free: false, starter: false, reader: false, ultra: true },
];

const CheckIcon: React.FC<{ color: string }> = ({ color }) => (
  <Check className={`w-4 h-4 ${color}`} />
);

const XIcon: React.FC = () => (
  <X className="w-4 h-4 text-slate-400" />
);

export const UpsellFeatureTable: React.FC = () => {
  return (
    <div className="mb-16">
      <h2 className="text-3xl font-bold text-slate-900 dark:text-white text-center mb-8">
        Full Feature Comparison
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[600px] border-collapse">
          <thead>
            <tr className="border-b border-slate-200 dark:border-slate-700">
              <th className="text-left py-4 px-4 text-sm font-semibold text-slate-900 dark:text-white">Feature</th>
              <th className="text-center py-4 px-4 text-sm font-semibold text-slate-500">Free</th>
              <th className="text-center py-4 px-4 text-sm font-semibold text-green-600 dark:text-green-400">Starter</th>
              <th className="text-center py-4 px-4 text-sm font-semibold text-blue-600 dark:text-blue-400">Reader</th>
              <th className="text-center py-4 px-4 text-sm font-semibold text-purple-600 dark:text-purple-400">Ultra</th>
            </tr>
          </thead>
          <tbody>
            {features.map((row, i) => (
              <tr
                key={row.feature}
                className={`border-b border-slate-100 dark:border-slate-800 ${
                  i % 2 === 0 ? 'bg-slate-50/50 dark:bg-slate-900/50' : ''
                }`}
              >
                <td className="py-3 px-4 text-sm text-slate-700 dark:text-slate-300">{row.feature}</td>
                <td className="py-3 px-4 text-center">{row.free ? <CheckIcon color="text-slate-500" /> : <XIcon />}</td>
                <td className="py-3 px-4 text-center">{row.starter ? <CheckIcon color="text-green-500" /> : <XIcon />}</td>
                <td className="py-3 px-4 text-center">{row.reader ? <CheckIcon color="text-blue-500" /> : <XIcon />}</td>
                <td className="py-3 px-4 text-center">{row.ultra ? <CheckIcon color="text-purple-500" /> : <XIcon />}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
